import moment from 'moment'
moment.suppressDeprecationWarnings = true;

export const dateFormatter = (pDate, pLocale) => {
  const _date = moment.utc(pDate).local()
  const locale = pLocale || window.localStorage.language || 'en-GB'
  const date = new Date(_date).toLocaleDateString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  })
  return date
}

export const dateLongMonthFormatter = pDate => {
  const _date = moment.utc(pDate).local()
  const locale = window.localStorage.language || 'en-GB'
  const date = new Date(_date).toLocaleDateString(locale, {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  })
  return date
}

export const dateTimeFormatter = pDate => {
  const _date = moment.utc(pDate).local()
  const locale = window.localStorage.language || 'en-GB'
  const date = new Date(_date).toLocaleString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
  return date
}

export const timeFormatter = pDate => {
  const _date = moment.utc(pDate).local()
  const locale = window.localStorage.language || 'en-GB'
  const date = new Date(_date).toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit'
  })
  return date
}

export const getISODateString = pDate => {
  const date =
    pDate.getFullYear() +
    '-' +
    ('0' + (pDate.getMonth() + 1)).slice(-2) +
    '-' +
    ('0' + pDate.getDate()).slice(-2)
  return date
}

export const getISODateTimeString = pDate => {
  const date =
    pDate.getFullYear() +
    '-' +
    ('0' + (pDate.getMonth() + 1)).slice(-2) +
    '-' +
    ('0' + pDate.getDate()).slice(-2) +
    ' ' +
    ('0' + pDate.getUTCHours()).slice(-2) +
    ':' +
    ('0' + pDate.getUTCMinutes()).slice(-2)
  return date
}

export const getISOTimeString = pDate => {
  const date =
    ('0' + pDate.getUTCHours()).slice(-2) +
    ':' +
    ('0' + pDate.getUTCMinutes()).slice(-2)
  return date
}

export const metersToFeetDecimal = pLength => {
  if (pLength !== null) {
    return pLength * 3.28084;
  }
  return null
}

export const feetToMetersDecimal = pLength => {
  if (pLength !== null) {
    return pLength / 3.28084;
  }
  return null
}

export const metersToFeet = pLength => {
  if (pLength !== null) {
    // let ft = parseInt(((pLength * 39.37) / 12), 10)
    // let inch = parseInt(((pLength * 39.37) % 12), 10)
    // return ft + '\' ' + inch + '\"'

    // convert meters to inches
    let inches = 39.3701 * pLength

    // get total feet; each foot is 12 inches
    let feet = Math.floor(inches / 12)

    // remaining inches
    let remaininginches = Math.round(inches % 12)

    if (remaininginches === 12) {
      feet += 1
      remaininginches = 0
    }
    return `${feet}' ${remaininginches}"`
  }
  return null
}

export const vdvMetersToFeet = pLength => {
  if (pLength !== null) {
    // let ft = parseInt(((pLength * 39.37) / 12), 10)
    // let inch = parseInt(((pLength * 39.37) % 12), 10)
    // return ft + '\' ' + inch + '\"'

    // convert meters to inches
    let inches = 39.3701 * pLength

    // get total feet; each foot is 12 inches
    let feet = Math.floor(inches / 12)

    // remaining inches
    let remaininginches = (feet >= 100) ? 0 : Math.round(inches % 12)

    if (remaininginches === 12) {
      feet += 1
      remaininginches = 0
    }
    return `${feet}' ${remaininginches}"`
  }
  return null
}

export const vdvPicofaradsUnitConversion = (pLength) => {
  if (pLength !== null) {
    // converting pF/m to pF/ft
    let picofaradsFoot = 0.3048 * pLength
    picofaradsFoot = Math.round(picofaradsFoot * 100) / 100
    return `${getFormattedNumberWithPrecision(picofaradsFoot, 1)}`
  }
  return null
}

export const picofaradsUnitConversion = (pLength) => {
  if (pLength !== null) {
    // converting pF/m to pF/ft
    let picofaradsFoot = 0.3048 * pLength
    picofaradsFoot = Math.round(picofaradsFoot * 100) / 100
    return `${getFormattedNumber(picofaradsFoot)}`
  }
  return null
}

export const getFormattedNumber = (value) => {
  // return number with 2 decimal value
  if (value === undefined || value === null) {
    return value
  }
  return ((Math.round(value * 100) / 100).toFixed(2))
}

export const getFormattedNumberWithPrecision = (value, fractionDigits) => {
  // return number with specified decimal value
  if (value === undefined || value === null) {
    return value
  }
  let factor = fractionDigits <= 0 ? 100 : Math.pow(10, fractionDigits);
  return ((Math.round(value * factor) / factor).toFixed(fractionDigits));
}

export const getDash = () => {
  const dashCode = '&#8212;';
  const parser = new DOMParser();
  return parser.parseFromString(dashCode, "text/html").body.textContent;
}

export const isSignalTEK10GType = (type) => {
  return type === null ? false : (type.includes("signaltek") || type.includes("navitek"));
}

export const isVDVType = (type) => {
  return type === 'vdvii' || type === 'vdviiplus' || type === 'vdviipro' || type === 'poepro';
}

export const isSignalTEKQTType = (type) => {
  return type === null ? false : type.includes("signaltekqt");
}

export const isNaviTEKType = (type) => {
  return type === null ? false : type.includes("navitek");
}

export const isCometType = (type) => {
  return type === 'comet_copper' || type === 'comet_fiber';
}

export const isSmartFlagSupportedDevice = (type) => {
  return isCometType(type);
}

export const getDateFormat = (locale) => {
  switch (locale) {
    case 'en-US': return 'MM/DD/YYYY';
    case 'jp-JP':
    case 'zh-CN': return 'YYYY/MM/DD';
    case 'de-DE':
    case 'ru-RU':
    case 'pl-PL': return 'DD.MM.YYYY';
    default: return 'DD/MM/YYYY';
  }
};

export const getSignalTEKPreset = (type) => {
  if (isSignalTEKQTType(type)) {
    return "SignalTEKQT";
  }
  else if (isNaviTEKType(type)) {
    return "NaviTEKIII";
  }
  return "SignalTEK10G";
}

export const getTreeviewNodeCategory = (type) => {
  switch (type) {
    case 'comet_copper':
    case 'comet_fiber':
      return 'comet';

    case 'signaltekqt':
    case 'signaltekqtpro':
      return 'signaltekqt';
    
    case 'navitekiii':
    case 'navitekiiipro':
      return 'navitekiii';

    default: break;
  }
  return type;
}

export const getWiremapImageUrl = (wiremapSubtestData, measurementUnit) => {
  let wiremapImage = wiremapSubtestData ? wiremapSubtestData.imageurl : null;
  if (measurementUnit === "feet") {
    return wiremapSubtestData && wiremapSubtestData.imageurlft && wiremapSubtestData.imageurlft.length ? wiremapSubtestData.imageurlft : wiremapImage;
  }
  return wiremapImage;
}

export const isNumber = (str) => {
  return !isNaN(str) && isFinite(str);
}

export const frequecyMHzToGHz = (frequency) => {
  if (!isNumber(frequency)) {
    return "-";
  }
  return parseInt(frequency, 10) / 1000.0;
}

export const degreeCelsiusToFahrenheit = (celsius) => {
  if (!isNumber(celsius)) {
    return "-";
  }

  return (32 + (celsius * 9.0 / 5.0)).toFixed(2);
}

export const getFiberSetupDiagram = (mode, singlefiber, isNavitek) => {
  let imgSource = '/images/FiberLengthLossTest/Qualification/';
  if (singlefiber) {
    imgSource += isNaviTEKType ? ((mode === "MM") ?  "FiberTest_single_MM.png" :  "FiberTest_single_SM.png") : "FiberTest_single.png";
  }
  else if (mode === "MM") {
    imgSource += "FiberTest_MM.png";
  }
  else {
    imgSource += "FiberTest_SM.png";
  }
  return imgSource;
}

export const formatDate = (timestamp) =>
  new Intl.DateTimeFormat(window.localStorage.language || 'en-GB', {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
}).format(new Date(timestamp * 1000));


/* ── Currency formatting ────────────────────────────────────── */

/**
 * Default symbol map used when supportedCurrencies is not available
 * from the Redux store.
 */
const DEFAULT_CURRENCY_SYMBOLS = {
  GBP: '£',
  USD: '$',
  EUR: '€',
};

/**
 * Format an amount as a currency string.
 *
 * @param {number}  amount           - The value to format. If the amount is
 *                                     stored in minor units (pence/cents),
 *                                     pass `{ minorUnits: true }` in options.
 * @param {string}  [currencyCode]   - ISO 4217 code, e.g. 'GBP'. Defaults to 'GBP'.
 * @param {object}  [options]        - Optional settings.
 * @param {boolean} [options.minorUnits=false]  - When true, divides amount by 100.
 * @param {Array}   [options.supportedCurrencies] - Array of
 *        `{ currencyCode, symbol }` objects from the Redux store. Falls back
 *        to DEFAULT_CURRENCY_SYMBOLS when omitted.
 * @returns {string} e.g. "£1,234.56"
 */
export const formatCurrency = (
  amount,
  currencyCode = 'GBP',
  options = {}
) => {
  const { minorUnits = false, supportedCurrencies } = options;

  let value = typeof amount === 'number' ? amount : parseFloat(amount);
  if (isNaN(value)) value = 0;
  if (minorUnits) value = value / 100;

  // Resolve symbol
  let symbol = DEFAULT_CURRENCY_SYMBOLS[currencyCode] || currencyCode + ' ';
  if (Array.isArray(supportedCurrencies)) {
    const match = supportedCurrencies.find(
      (c) => (c.currencyCode || c.code || '').toUpperCase() === currencyCode.toUpperCase()
    );
    if (match && match.symbol) {
      symbol = match.symbol;
    }
  }

  // Use Intl when available for locale-aware grouping
  try {
    const formatted = new Intl.NumberFormat('en-GB', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
    return `${symbol}${formatted}`;
  } catch {
    return `${symbol}${value.toFixed(2)}`;
  }
};

